import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';


import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class CertificationMatters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      dados: [],
      sigtrip_select: [],
      sigmec_select: [],
      sigtrip_id: null,
      sigmec_id: null,
      matter_id: null,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.openModal = this.openModal.bind(this);
    this.editMatter = this.editMatter.bind(this);
  }
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materias/certificados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data.matters, sigtrip_select: responseJson.data.sigtrip_select, sigmec_select: responseJson.data.sigmec_select});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  editMatter(event) {
    event.preventDefault();
    
    var self = this;
    self.handleAlert('', '', 'open');
    var datasave = {
      sigtrip_id: this.state.sigtrip_id,
      sigmec_id: this.state.sigmec_id,
      matter_id: this.state.matter_id,
    };

    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/materia/certificado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.setState({dados: responseJson.data})
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  openModal (row) {
    var self = this;
    self.setState({
      sigtrip_id: row.sigtrip_id,
      sigmec_id: row.sigmec_id,
      matter_id: row.id,
      name: row.name,
      modal: true,
    });
  }

  ActionsButtons (cell, row) {
    var url = '/materia/editar/' + cell;

    var botao = (
      <div>
        <button className={'btn btn-primary btn-sm'} onClick={() => this.openModal(row)}>
          <i className="fa fa-fw fa-pencil"></i>
        </button>
      </div>
    );

    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de materias</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há materias cadastrados', defaultSortName: 'name', defaultSortOrder: 'ASC'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Matéria</TableHeaderColumn>

        <TableHeaderColumn dataField="sigtrip_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>ID - SIGTRIP</TableHeaderColumn>

        <TableHeaderColumn dataField="sigtrip" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Nome - SIGTRIP</TableHeaderColumn>

        <TableHeaderColumn dataField="sigmec_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>ID - SIGMEC</TableHeaderColumn>

        <TableHeaderColumn dataField="sigmec" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Nome - SIGMEC</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Editar matéria - {this.state.name}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, sigtrip_id: null, sigmec_id: null, matter_id: null})}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.editMatter}>
        <div className="row">
          <div className="form-group col-md-6">
            <label>Certificado - SIGTRIP:</label>
            <Select
                className="form-field-name"
                name="sigtrip_id"
                value={this.state.sigtrip_id}
                searchable={true}
                placeholder={'Selecionar Certificado - SIGTRIP'}
                onChange={this.handleSelectChange.bind(this, 'sigtrip_id')}
                options={this.state.sigtrip_select}
              />    
          </div>     
          <div className="form-group col-md-6">
            <label>Certificado - SIGMEC:</label>
            <Select
                className="form-field-name"
                name="sigmec_id"
                value={this.state.sigmec_id}
                searchable={true}
                placeholder={'Selecionar Certificado - SIGMEC'}
                onChange={this.handleSelectChange.bind(this, 'sigmec_id')}
                options={this.state.sigmec_select}
              />    
          </div>     
        </div>
        <div className="form-group">
          <button className="btn btn-primary btn-block" type="submit"><i className="fa fa-fw fa-save"></i> Editar</button>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, sigtrip_id: null, sigmec_id: null, matter_id: null})}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default CertificationMatters;



// WEBPACK FOOTER //
// ./src/Components/Matters/CertificationMatters.js